export default __webpack_public_path__ + "static/media/Excite WLL.a7105708.png";